import React from 'react';
import { Badge } from '@chakra-ui/react';

const STYLES = {
  passed: { color: 'status.pass', bg: 'status.passBg' },
  failed: { color: 'status.failText', bg: 'status.failBg' },
  flaky: { color: 'status.flakyText', bg: 'status.flakyBg' },
  skipped: { color: 'status.skip', bg: 'status.skipBg' },
  running: { color: 'info.500', bg: 'info.50' },
  cancelled: { color: 'gray.500', bg: 'gray.100' },
};

export default function StatusBadge({ status, ...props }) {
  const normalized = (status || '').toLowerCase();
  const s = STYLES[normalized] || { color: 'gray.500', bg: 'gray.100' };
  return (
    <Badge
      textTransform="capitalize"
      fontWeight="700"
      fontSize="11px"
      letterSpacing="0.02em"
      borderRadius="full"
      px={2.5}
      py={0.5}
      {...s}
      {...props}
    >
      {normalized || 'unknown'}
    </Badge>
  );
}
